const ADD_EMPLOYERS = 'ADD_EMPLOYERS';

const setEmployers = employers => ({
  type: ADD_EMPLOYERS,
  payload: {
    employers
  }
});

export { ADD_EMPLOYERS, setEmployers };
